export const objectHasField = (object, field) => Object.prototype.hasOwnProperty.call(object, field);
